import { Form, Input, Button, notification } from "antd";
import { useState } from "react";
import { Turnstile } from "@marsidev/react-turnstile";
import { LoadingOutlined } from "@ant-design/icons";
function ContactForm(args) {
  const validateMessages = {
    // eslint-disable-next-line
    required: "${label} bölümü gereklidir",
    types: {
      // eslint-disable-next-line
      email: "${label} geçerli değil", // eslint-disable-next-line
      number: "${label} bir sayı değil",
    },
    number: {
      // eslint-disable-next-line
      range: "${label} en az ${min}, en fazla ${max} olabilir",
    },
  };

  const [name, setName] = useState("");
  const [mail, setMail] = useState("");
  const [msg, setMsg] = useState("");

  const [token, setToken] = useState(null);

  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type,
    errorMsg,
    placement = args.device === "pc" ? "bottomRight" : "topRight"
  ) => {
    api[type === "no_bot" || type === "fields_missing" ? "error" : type]({
      title: `Bildirim`,
      description:
        type === "info" ? (
          "Posta gönderiliyor..."
        ) : type === "success" ? (
          "Posta başarıyla gönderildi!"
        ) : type === "no_bot" ? (
          "Captcha doğrulaması yapılmadı!"
        ) : type === "fields_missing" ? (
          "Lütfen tüm boşlukları doldurun."
        ) : (
          <p>
            Bir hata oluştu :( <br></br> {errorMsg && errorMsg}
          </p>
        ),
      icon: type === "info" && <LoadingOutlined style={{ color: "#108ee9" }} />,
      placement,
    });
  };

  const submit = async (e) => {
    await fetch("https://api.zenofy.tr/contact", {
      method: "POST",
      body: JSON.stringify({
        name: name && name,
        email: mail && mail,
        message: msg && msg,
        turnstileToken: token && token,
      }),
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.success) {
          openNotification("success");
        } else {
          openNotification("error", json.error);
        }
      });
  };

  return (
    <>
      {contextHolder}
      <Form
        colon={false}
        variant="outlined"
        size="large"
        name="contact"
        style={{
          zIndex: "1",
          minWidth: args.device === "pc" ? 1000 : "90vw",
          fontSize: args.device === "pc" ? "calc(10px + 5vw)" : "3rem",
          rowGap: "4rem",
        }}
        validateMessages={validateMessages}
        requiredMark={(labelNode, info) => (
          <span>
            {info.required && (
              <span
                style={{
                  fontSize: "1.5rem",
                  color: "red",
                  marginRight: ".5rem",
                }}
              >
                *
              </span>
            )}
          </span>
        )}
      >
        <Form.Item name={["name"]} label="İsim" rules={[{ required: true }]}>
          <div className="floating-field">
            <Input
              style={{ backgroundColor: "transparent" }}
              value={name}
              className="floating-input"
              placeholder=" "
              onChange={(e) => setName(e.target.value)}
            />
            <label className="floating-label">İsim</label>
          </div>
        </Form.Item>
        <Form.Item
          name={["email"]}
          label="E-Posta"
          rules={[{ type: "email", required: true }]}
        >
          <div className="floating-field">
            <Input
              style={{ backgroundColor: "transparent" }}
              className="floating-input"
              value={mail}
              placeholder=" "
              onChange={(e) => setMail(e.target.value)}
            />
            <label className="floating-label">E-Posta</label>
          </div>
        </Form.Item>
        <Form.Item
          name={["message"]}
          label="Mesaj"
          rules={[{ required: true }]}
        >
          <div className="floating-field">
            <Input.TextArea
              style={{ backgroundColor: "transparent" }}
              className="floating-input"
              value={msg}
              placeholder=" "
              onChange={(e) => setMsg(e.target.value)}
            />
            <label className="floating-label">Mesaj</label>
          </div>
        </Form.Item>
        <Form.Item>
          <Turnstile
            siteKey={process.env.REACT_APP_VITE_TURNSTILE_SITE_KEY}
            onSuccess={setToken}
          />
        </Form.Item>
        <Form.Item label={null}>
          <Button
            onClick={(e) => {
              if (!name || !mail || !msg)
                return openNotification("fields_missing");
              else {
                if (!token) return openNotification("no_bot");
                else {
                  openNotification("info");
                  submit(e);
                }
              }
            }}
            type="primary"
            htmlType="submit"
          >
            Gönder
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}

export { ContactForm };
